import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { PuzzlesPage, PuzzlesPageProps } from './PuzzlesPage'

// Strip the 'onEvent' from PuzzlesPageProps into another type
export type PuzzlesPageRegistrationProps = Omit<PuzzlesPageProps, 'onEvent'>

export const PuzzlesPageRegistration = createRegisterableComponent(
    'puzzles-page',
    (props: PuzzlesPageRegistrationProps, services) => {
        return <PuzzlesPage {...props} onEvent={services.onEvent} />
    },
)
